const FEED_TYPES = {
  RECOMMENDATION: 'recommendation',
};

const FEED_TITLES = {
  JOURNEY: 'Start your journey',
};

const MEDIA_TYPES = {
  SERIES: 'series',
};

export { FEED_TITLES, FEED_TYPES, MEDIA_TYPES };
